export const CREDIT_REASONS = [
  { id: 'return', label: 'Returned Products' },
  { id: 'billing_error', label: 'Billing Error' },
  { id: 'refund', label: 'Refund Received' },
  { id: 'discount', label: 'Volume Discount' },
  { id: 'overpayment', label: 'Overpayment' }
];

export const CREDIT_STATUSES = {
  AVAILABLE: { label: 'Available', color: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  PARTIAL: { label: 'Partially Applied', color: 'bg-blue-50 text-blue-700 border-blue-200' },
  CLOSED: { label: 'Fully Applied', color: 'bg-slate-100 text-slate-500 border-slate-200' },
  VOID: { label: 'Voided', color: 'bg-rose-50 text-rose-700 border-rose-200' }
};